var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.063a.69.69 0 0 1 .688.687v7.563h7.562a.687.687 0 1 1 0 1.374h-7.562v7.563a.687.687 0 1 1-1.376 0v-7.562H3.75a.687.687 0 1 1 0-1.376h7.563V3.75A.687.687 0 0 1 12 3.063"
  })));
};
export default SvgPlus;